import { el, replaceChildren } from '../lib/dom'
import { createVersionList } from './versionList'
import { createWorkbench } from './Workbench'
import type { Page, PageContext } from './types'

const LOGIN_PATH = '/auth/login'

const hero = (ctx: PageContext): HTMLElement =>
  el(
    'section',
    { class: 'hero', 'aria-labelledby': 'hero-heading' },
    el('h1', { id: 'hero-heading', class: 'prompt' }, ctx.prompt.text),
    el(
      'p',
      { class: 'prompt-sub' },
      'A pixel town where every line is typed by hand. Watch how a plot was typed, then ',
      el('a', { href: LOGIN_PATH, class: 'btn btn-primary btn-inline' }, 'log in with GitHub'),
      ' to claim one.',
    ),
  )

/** Logged in (or in dev): the workbench, then the town's replays. Logged out: hero + replays. */
export const createHomePage = (ctx: PageContext): Page => {
  const showWorkbench = ctx.me !== null || import.meta.env.DEV
  const workbench = showWorkbench ? createWorkbench(ctx) : null
  const list = el(
    'div',
    { class: 'list-host', 'aria-busy': 'true' },
    el('p', { class: 'empty' }, 'loading the town…'),
  )
  const element = el(
    'div',
    { class: 'page page-home' },
    workbench ? workbench.element : hero(ctx),
    el(
      'section',
      { class: 'town', 'aria-labelledby': 'town-heading' },
      el('h2', { id: 'town-heading', class: 'section-title' }, 'replays in town'),
      list,
    ),
  )

  void ctx.api
    .listVersions()
    .then((versions) => replaceChildren(list, [createVersionList(versions)]))
    .catch(() =>
      replaceChildren(list, [el('p', { class: 'empty' }, 'The town is unreachable right now.')]),
    )
    .finally(() => list.removeAttribute('aria-busy'))

  return {
    element,
    suspend: () => workbench?.suspend?.(),
    resume: () => workbench?.resume?.(),
    destroy: () => workbench?.destroy(),
  }
}
